import script from "./PatientBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientBackground.vue?vue&type=script&setup=true&lang=ts"

import "./PatientBackground.vue?vue&type=style&index=0&id=61cd1981&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cd1981"]])

export default __exports__